import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { of, Subject, Observable, forkJoin } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  userData: any;
  companyData: any;
  companyDataSubject = new Subject<any>();
  userInfoDataSubject = new Subject<any>();
  userCompanyDetails: any = null;
  hasUserInfoRequestBeenMade: boolean = false;
  hasCompanyRequestBeenMade: boolean = false;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  private hasUserAndCompanyDetailsRequestBeenMade: boolean = false;
  private userInfoAndCompanyDetailsArr: any;
  public hasZedaBeenInitialized: boolean = false;

  constructor(private http: HttpClient) { }

  logout() {
    return this.http.get<any>('/dashboard/logout').pipe(
      map((res: Response) => {
        const body = res;
        this.clearCompanyDetails();
        this.clearUserInfo();
        return body || {};
      })
    );
  }

  public getCompanyDetailsReady(): Observable<any> {
    return this.companyDataSubject.asObservable();
  }

  public getUserInfoDetailsReady(): Observable<any> {
    return this.userInfoDataSubject.asObservable();
  }

  clearCompanyDetails() {
    this.hasCompanyRequestBeenMade = false;
    this.userCompanyDetails = null;
  }

  clearUserInfo() {
    this.userData = null;
    this.hasUserInfoRequestBeenMade = false;
  }

  getUserInfo(cb = null) {
    const _this = this;
    if (_this.userData && typeof _this.userData === 'object' && !_this.userData.is_error) {
      cb && cb(_this.userData);
      return;
    }
    _this.getUserInfoDetailsReady().subscribe(userInfo => {
      cb && cb(userInfo)
    });

    if (_this.hasUserInfoRequestBeenMade) {
      return;
    }
    _this.hasUserInfoRequestBeenMade = true;
    _this.fetchUserInfoViaNetwork().subscribe((data: any) => {
      if (data.is_error) {
        _this.hasUserInfoRequestBeenMade = false;
      }
      cb && cb(data);
    });
  }

  fetchUserInfoViaNetwork() {
    const _this = this;
    return this.http.get<any>('/dashboard/getuserinfo').pipe(
      map((res: Response) => {
        const body = res;
        _this.userData = body || {};
        _this.userInfoDataSubject.next(body || {});
        return body || {};
      })
    );
  }
  getuserActions() {
    return this.http.get<any>('/dashboard/getuseractions').pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fakeResponse(dataName?) {
    return of((new HttpResponse({ status: 200, body: dataName })).body);
  }

  getUserCompany(cb = null) {
    const _this = this;
    if (_this.userCompanyDetails && typeof _this.userCompanyDetails === 'object' && !_this.userCompanyDetails.is_error) {
      cb && cb(_this.userCompanyDetails);
      return;
    }
    _this.getCompanyDetailsReady().subscribe(userCompanyDetails => {
      cb && cb(userCompanyDetails)
    });

    if (_this.hasCompanyRequestBeenMade) {
      return;
    }
    this.hasCompanyRequestBeenMade = true;
    _this.getuserCompanyDetails().subscribe((data: any) => {
      _this.userCompanyDetails = data;
      _this.companyDataSubject.next(data);
      if (data.is_error) {
        _this.hasCompanyRequestBeenMade = false;
      }
    });
  }

  getuserCompanyDetails() {
    return this.http.get<any>('/dashboard/getusercompanies?dashboard_version=3.0').pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  updateUserInfo(profileInfo) {
    const endPoint = 'dashboard/profile/updateuserinfo/';
    const data: any = {};
    if (profileInfo.name) {
      data.user_name = profileInfo.name;
    }
    if (profileInfo.newPassword) {
      data.password = profileInfo.newPassword;
    }
    return this.http.post<any>(endPoint, data, this.httpOptions).pipe(
      map(this.extractData.bind(this)) // callback fn loses this from the scope, bind this value with current scope
    );
  }

  private extractData(res: Response) {
    const body = res;
    this.clearCompanyDetails();
    this.clearUserInfo();
    this.getUserCompany();
    this.getUserInfo();
    return body || {};
  }

  sendAttributesDataForSmartechSDK() {
    if (this.hasUserAndCompanyDetailsRequestBeenMade && this.userInfoAndCompanyDetailsArr && this.userInfoAndCompanyDetailsArr.length) {
      this.processAndSendAttributesData();
      return;
    }
    forkJoin([
      this.getuserCompanyDetails(),
      this.fetchUserInfoViaNetwork()
    ]).subscribe((res: any) => {
      this.hasUserAndCompanyDetailsRequestBeenMade = true;
      this.userInfoAndCompanyDetailsArr = res;
      this.processAndSendAttributesData();
    });
  }

  processAndSendAttributesData() {
    try {
      const companyDetails = this.userInfoAndCompanyDetailsArr[0].api_response.companies[0];
      const userDetails = this.userInfoAndCompanyDetailsArr[1].api_response;
      const splitBySpace = userDetails.name.split(' ');

      const payload = {
        'pk^email': userDetails.email,
        'FIRSTNAME': splitBySpace[0].trim(),
        'LASTNAME': splitBySpace.length > 1 ? splitBySpace[1].trim() : '',
        'PANEL_NAME': companyDetails.name
      };
      window['smartech']('contact', '', payload);
    } catch (error) {
      // console.log(error);
    }
  }

  modifyAccountLockStatus(email, userId) {
    const apiUrl = 'dashboard/unlockuser';
    const data = {
      email: email,
      user_id: userId
    };

    return this.http.post<any>(apiUrl, data, this.httpOptions);
  }
}
